


















































import { Component, Vue } from "vue-property-decorator";
import SoundManager from "../soundManager";
import Button from "./Button.vue";

@Component<Intro>({
  components: {
    Button,
  },
})
export default class Intro extends Vue {
  private hasTouch() {
    return (
      "ontouchstart" in window || // html5 browsers
      navigator.maxTouchPoints > 0 || // future IE
      navigator.msMaxTouchPoints > 0
    ); // current IE10
  }
  mounted() {}
  public clicked(): void {
    SoundManager.btnSound();
    this.$emit("next", this);
  }
}
